module.exports = "<p>\n  analytics-page works!\n</p>\n"